import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.startsWith("hi") ? "hi" : "en";

  const change = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="inline-flex items-center gap-1.5 rounded-md border border-border bg-white p-0.5" data-testid="lang-switcher">
      {!compact && <Globe className="w-3.5 h-3.5 text-muted-foreground ml-1.5" />}
      <button
        type="button"
        onClick={() => change("en")}
        data-testid="lang-en-btn"
        className={`text-xs font-semibold px-2.5 py-1 rounded transition-colors ${
          current === "en" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted"
        }`}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => change("hi")}
        data-testid="lang-hi-btn"
        className={`text-xs font-semibold px-2.5 py-1 rounded transition-colors ${
          current === "hi" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted"
        }`}
      >
        हिन्दी
      </button>
    </div>
  );
}
